/* Teckel Paris — fiche produit : galerie, description repliable, lien vers les avis, avis clients (Judge.me)
   Léger, sans bibliothèque. Ne touche pas au JavaScript natif de Dawn (variantes, panier, paiement). */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.9 6.2 6.8.8-5 4.6 1.3 6.7L12 17.5l-6 3.3 1.3-6.7-5-4.6 6.8-.8z"/></svg>';

  /* ---------- Galerie ---------- */
  if (!customElements.get('fp-gallery')) {
    customElements.define(
      'fp-gallery',
      class FpGallery extends HTMLElement {
        connectedCallback() {
          this.slides = Array.prototype.slice.call(this.querySelectorAll('.fp-gallery__slide[data-media-id]'));
          this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.fp-thumb'));
          this.dots = Array.prototype.slice.call(this.querySelectorAll('.fp-dot'));
          this.track = this.querySelector('[data-fp-track]');
          this.thumbsWrap = this.querySelector('[data-fp-thumbs]');
          if (this.slides.length < 2) return;

          var self = this;
          this.thumbs.forEach(function (thumb) {
            thumb.addEventListener('click', function () {
              self.showId(thumb.dataset.mediaId);
            });
          });

          /* Flèches sur l'image et flèches des miniatures */
          Array.prototype.forEach.call(this.querySelectorAll('[data-fp-prev]'), function (btn) {
            btn.addEventListener('click', function () { self.step(-1); });
          });
          Array.prototype.forEach.call(this.querySelectorAll('[data-fp-next]'), function (btn) {
            btn.addEventListener('click', function () { self.step(1); });
          });

          /* Glissement au doigt sur la grande image */
          var main = this.querySelector('[data-fp-main]');
          var startX = 0;
          var startY = 0;
          main.addEventListener('touchstart', function (e) {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
          }, { passive: true });
          main.addEventListener('touchend', function (e) {
            var dx = e.changedTouches[0].clientX - startX;
            var dy = e.changedTouches[0].clientY - startY;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.step(dx < 0 ? 1 : -1);
          }, { passive: true });

          /* Flèches des miniatures visibles seulement si les miniatures dépassent */
          this.checkOverflow = this.checkOverflow.bind(this);
          if ('ResizeObserver' in window && this.track) {
            this.ro = new ResizeObserver(this.checkOverflow);
            this.ro.observe(this.track);
          }
          window.addEventListener('load', this.checkOverflow);
          this.checkOverflow();

          /* Variante avec sa propre image */
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
              var variant = event && event.data && event.data.variant;
              if (variant && variant.featured_media) self.showId(String(variant.featured_media.id));
            });
          }
        }

        disconnectedCallback() {
          if (this.unsub) this.unsub();
          if (this.ro) this.ro.disconnect();
        }

        checkOverflow() {
          if (!this.track || !this.thumbsWrap) return;
          var fits = this.track.scrollWidth <= this.track.clientWidth + 2;
          this.thumbsWrap.classList.toggle('fp-thumbs--fits', fits);
        }

        index() {
          for (var i = 0; i < this.slides.length; i++) {
            if (this.slides[i].classList.contains('is-active')) return i;
          }
          return 0;
        }

        step(dir) {
          var i = (this.index() + dir + this.slides.length) % this.slides.length;
          this.showId(this.slides[i].dataset.mediaId);
        }

        showId(id) {
          var found = false;
          this.slides.forEach(function (slide) {
            var active = slide.dataset.mediaId === id;
            if (active) found = true;
            slide.classList.toggle('is-active', active);
            if (active) slide.removeAttribute('aria-hidden');
            else {
              slide.setAttribute('aria-hidden', 'true');
              var video = slide.querySelector('video');
              if (video) video.pause();
            }
          });
          if (!found) return;
          this.dots.forEach(function (dot) {
            dot.classList.toggle('is-active', dot.dataset.mediaId === id);
          });
          var track = this.track;
          this.thumbs.forEach(function (thumb) {
            var active = thumb.dataset.mediaId === id;
            thumb.classList.toggle('is-active', active);
            if (active) {
              thumb.setAttribute('aria-current', 'true');
              if (track) {
                var left = thumb.offsetLeft - track.offsetLeft;
                if (left < track.scrollLeft || left + thumb.offsetWidth > track.scrollLeft + track.clientWidth) {
                  track.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
                }
              }
            } else {
              thumb.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  /* ---------- Description repliée (4 lignes) avec « Lire la suite » ---------- */
  function initDesc(body) {
    if (body.dataset.fpReady) return;
    body.dataset.fpReady = 'true';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fp-desc__more';
    btn.textContent = 'Lire la suite';
    btn.hidden = true;
    body.insertAdjacentElement('afterend', btn);
    body.classList.add('is-clamped');
    function check() {
      if (!body.classList.contains('is-clamped')) return;
      btn.hidden = body.scrollHeight <= body.clientHeight + 4;
    }
    btn.addEventListener('click', function () {
      var clamped = body.classList.toggle('is-clamped');
      btn.textContent = clamped ? 'Lire la suite' : 'Réduire';
      btn.hidden = false;
    });
    check();
    window.addEventListener('load', check);
    window.addEventListener('resize', check);
  }

  /* ---------- Pastille de notation : défilement doux vers les avis ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-fp-to-reviews]');
    if (!link) return;
    var target = document.getElementById('avis');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- Avis clients (données Judge.me) ---------- */
  function text(el) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function stars(score) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      html += i <= Math.round(score) ? STAR : STAR.replace('<svg ', '<svg class="is-off" ');
    }
    return html;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initReviews(root) {
    if (root.dataset.fpReady) return;
    root.dataset.fpReady = 'true';

    var track = root.querySelector('[data-fp-track]');
    var empty = root.querySelector('[data-fp-empty]');
    var writeBtn = root.querySelector('[data-fp-write]');
    var widget = root.querySelector('.jdgm-widget');
    var built = false;

    /* Bloc « Avis » de l'application Judge.me ajouté dans l'éditeur : déplacé ici, dans la section Avis clients */
    var external = Array.prototype.filter.call(
      document.querySelectorAll('.jdgm-review-widget, .jm-review-widget'),
      function (el) { return !root.contains(el); }
    )[0];
    if (external) {
      var holder = root.querySelector('.fp-jdgm');
      var block = external.closest('.shopify-app-block') || external;
      if (widget) widget.remove();
      holder.appendChild(block);
      widget = external;
      root.classList.add('fp-reviews--app');
      if (empty) empty.hidden = true;
    }

    function writeLink() {
      return widget && widget.querySelector('.jdgm-write-rev-link');
    }

    function refreshWriteButton() {
      if (writeBtn) writeBtn.hidden = !writeLink() || root.classList.contains('fp-reviews--app');
    }

    if (writeBtn) {
      writeBtn.addEventListener('click', function () {
        var link = writeLink();
        if (link) link.click();
      });
    }

    function build() {
      if (built || !widget) return;
      var nodes = widget.querySelectorAll('.jdgm-rev');
      refreshWriteButton();
      if (!nodes.length) return;
      built = true;
      root.classList.add('fp-reviews--parsed');

      var total = 0;
      var cards = [];
      Array.prototype.forEach.call(nodes, function (rev) {
        var ratingEl = rev.querySelector('.jdgm-rev__rating');
        var score = ratingEl ? parseFloat(ratingEl.getAttribute('data-score')) || 0 : 0;
        total += score;
        var dateEl = rev.querySelector('.jdgm-rev__timestamp');
        var date = dateEl ? dateEl.getAttribute('data-content') || text(dateEl) : '';
        if (date && /^\d{4}-\d{2}-\d{2}/.test(date)) {
          var d = new Date(date.replace(' ', 'T'));
          if (!isNaN(d)) date = d.toLocaleDateString('fr-FR');
        }
        var title = text(rev.querySelector('.jdgm-rev__title'));
        var body = text(rev.querySelector('.jdgm-rev__body'));
        var author = text(rev.querySelector('.jdgm-rev__author'));
        var verified = !!rev.querySelector('.jdgm-rev__buyer-badge');
        var extras = [];
        Array.prototype.forEach.call(rev.querySelectorAll('.jdgm-rev__cf-ans'), function (cf) {
          var t = text(cf.querySelector('.jdgm-rev__cf-ans__value')) || text(cf);
          if (t) extras.push(t);
        });

        cards.push(
          '<article class="fp-review" role="listitem">' +
            '<div class="fp-review__top"><span class="fp-stars fp-review__stars" role="img" aria-label="Note : ' + score + ' sur 5">' + stars(score) + '</span>' +
            (date ? '<span class="fp-review__date">' + escapeHtml(date) + '</span>' : '') + '</div>' +
            (title ? '<h3 class="fp-review__title">' + escapeHtml(title) + '</h3>' : '') +
            (body ? '<p class="fp-review__body">' + escapeHtml(body) + '</p>' : '') +
            '<div class="fp-review__foot">' +
              (author ? '<span class="fp-review__author">' + escapeHtml(author) + '</span>' : '') +
              (verified ? '<span class="fp-review__verified">✓ Achat vérifié</span>' : '') +
              (extras.length ? '<span class="fp-review__extra">' + escapeHtml(extras.join(' · ')) + '</span>' : '') +
            '</div>' +
          '</article>'
        );
      });

      track.innerHTML = cards.join('');
      track.hidden = false;
      if (empty) empty.hidden = true;

      /* En-tête : note moyenne si la note n'est pas déjà fournie par Shopify */
      var summary = root.querySelector('[data-fp-summary]');
      if (summary && summary.hidden) {
        var avg = Math.round((total / nodes.length) * 10) / 10;
        var count = parseInt(root.dataset.count, 10) || nodes.length;
        var ventes = parseInt(root.dataset.ventes, 10) || 0;
        summary.querySelector('[data-fp-score]').textContent = String(avg).replace('.', ',');
        summary.querySelector('[data-fp-based]').textContent =
          'Basé sur ' + count + ' avis' + (ventes > 0 ? ' · +' + ventes + ' vendus' : '');
        summary.hidden = false;
      }

      autoplay(root, track, nodes.length);
    }

    if (widget) {
      build();
      var mo = new MutationObserver(function () {
        build();
        refreshWriteButton();
        if (built) mo.disconnect();
      });
      mo.observe(widget, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); refreshWriteButton(); }, 20000);
    }
  }

  function autoplay(root, track, count) {
    if (reduceMotion) return;
    var speed = parseInt(root.dataset.speed, 10) || 5000;
    var mobile = window.matchMedia('(max-width: 749px)');
    var timer = null;
    var paused = false;
    var resume = null;

    function enabled() {
      return mobile.matches ? count >= 3 : count >= 4;
    }

    function next() {
      var card = track.querySelector('.fp-review');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var stepPx = card.getBoundingClientRect().width + gap;
      var max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= max - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: stepPx, behavior: 'smooth' });
    }

    function start() {
      clearInterval(timer);
      timer = null;
      if (paused || document.hidden || !enabled()) return;
      timer = setInterval(next, speed);
    }

    function pause() {
      paused = true;
      clearInterval(timer);
      timer = null;
    }

    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', function () { paused = false; start(); });
    track.addEventListener('touchstart', function () { pause(); clearTimeout(resume); }, { passive: true });
    track.addEventListener('touchend', function () {
      clearTimeout(resume);
      resume = setTimeout(function () { paused = false; start(); }, speed);
    }, { passive: true });
    document.addEventListener('visibilitychange', start);
    if (mobile.addEventListener) mobile.addEventListener('change', start);
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-fp-reviews]').forEach(initReviews);
    document.querySelectorAll('.fp-info__inner > .product__description').forEach(initDesc);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
